import { Link } from 'react-router-dom';

interface EncyclopediaCard {
  icon: string;
  title: string;
  description: string;
  to: string;
}

const encyclopediaCards: EncyclopediaCard[] = [
  {
    icon: 'ri-book-open-line',
    title: 'Корпоративное обучение',
    description: 'Полное руководство по организации корпоративного обучения: виды, форматы, методы и оценка эффективности.',
    to: '/enciklopediya-korporativnogo-obucheniya/chto-takoe-korporativnoe-obuchenie',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Обучение персонала',
    description: 'Системный подход к обучению сотрудников: от диагностики потребностей до измерения результатов.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Обучение отдела продаж',
    description: 'Тренинги и методики для роста конверсии, повышения среднего чека и построения долгосрочных отношений с клиентами.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-otdela-prodazh',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Тренинг для руководителей',
    description: 'Развитие управленческих компетенций: лидерство, принятие решений, мотивация команды и стратегическое мышление.',
    to: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: 'Развитие Soft Skills',
    description: 'Эмоциональный интеллект, коммуникации, тайм-менеджмент и адаптивность — ключевые гибкие навыки для современных команд.',
    to: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
  },
  {
    icon: 'ri-group-line',
    title: 'Командообразование',
    description: 'Современные методики тимбилдинга: бизнес-игры, стратегические сессии и программы сплочения коллектива.',
    to: '/enciklopediya-korporativnogo-obucheniya/komandoobrazovanie',
  },
  {
    icon: 'ri-user-add-line',
    title: 'Адаптация сотрудников',
    description: 'Построение эффективной программы онбординга: снижение текучести, ускорение выхода на продуктивность.',
    to: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov',
  },
  {
    icon: 'ri-building-line',
    title: 'Корпоративная академия',
    description: 'Создание внутреннего учебного центра компании: структура, программы, оценка и развитие талантов.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'Оценка эффективности обучения',
    description: 'Модель Киркпатрика, расчёт ROI обучения, метрики и инструменты для измерения результативности тренингов.',
    to: '/enciklopediya-korporativnogo-obucheniya/ocenka-effektivnosti-obucheniya',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Разработка программ обучения',
    description: 'Проектирование корпоративных программ под задачи бизнеса: от анализа потребностей до внедрения и сопровождения.',
    to: '/enciklopediya-korporativnogo-obucheniya/razrabotka-programm-obucheniya',
  },
];

export default function EncyclopediaSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-book-read-line"></i>
            Knowledge Hub
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Энциклопедия корпоративного обучения
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Полный экспертный справочник по всем направлениям корпоративного обучения. Разберитесь в теме глубоко, прежде чем принимать решения.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {encyclopediaCards.map((card, index) => (
            <Link
              key={index}
              to={card.to}
              className="group bg-gray-50 rounded-xl p-6 hover:shadow-lg hover:bg-teal-50/50 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${card.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                {card.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-1">
                {card.description}
              </p>
              <span className="inline-flex items-center text-teal-600 font-semibold text-sm group-hover:gap-2 transition-all gap-1 whitespace-nowrap">
                Подробнее <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}